import { tier } from "../Hooks/useSubscription";
import { VerificationStatusType } from "./General";
import { Affiliate } from "./Talent";

export interface Client {
    locator: string;
    type: string;
    first_name: string;
    last_name: string;
    company: string;
    email: string;
    country: string;
    phone: string;
    profile_completeness: string;
    posted_jobs: string[];
    bookmarked_talents: string[];
    profile_picture: string;
    description: string;
    languages: string[];
    verification_status: VerificationStatusType;
    affiliate: Affiliate;
    subscription: {
        tier: tier;
        type: string;
        createdAt: string;
        updatedAt: string;
        endDate?: string;
        renew: boolean;
    };
    notifications: {
        email: boolean;
        text: boolean;
        payment: boolean;
        messages: boolean;
        marketing: boolean;
    },
    stripe: {
        customer_id: string;
        subscription_id: string;
        subscription_type: string;
        next_payment: string;
        default_payment_id: string;
    },
    active: boolean;
    talent_invites: {talent_locator: string, job_locator: string, invite_date: string;}[]
}

export interface clientRegistrationRequest {
    first_name: string | undefined;
    last_name: string | undefined;
    email: string | undefined;
    password: string | undefined;
    type: string | undefined;
    company: string | undefined;
    country: string | undefined;
    phone: string | undefined;
    date_of_birth: string | undefined;
}

export interface bookmarkTalentRequest {
    locator: string;
    bookmarks: string[];
}

export enum ClientType {
    'Individual',
    'Company'
}

export const SubscriptionTier = {
    Starter: 'starter',
    PremiumAfrica: 'premium_africa',
    Premium: 'premium',
    Enterprise: 'enterprise'
}

export interface ComposeMessageTalent {
    locator: string;
    first_name: string;
    last_name: string;
    profile_picture: string;
    title: string;
}

export interface ClientDashboardResponse {
    profileCompleteness: number;
    profileComplete: boolean;
    numberOfBookmarkedTalents: number;
    lastBookmarkedTalent?: string;
    numberOfJobsPosted: number;
    numberOfActiveJobs: number;
    lastJobPosting: string;
    completedSections: {
        description: boolean;
        languages: boolean;
        company: boolean;
        profilePicture: boolean;
    }
}
